$(function ($) {



$('#parentHorizontalTab').easyResponsiveTabs({
      type: 'horizontal', //Types: default, vertical, accordion
      width: 'auto', //auto or any width like 600px
      fit: true, // 100% fit in a container
      closed: 'accordion', // Start closed if in accordion view
      tabidentify: 'hor_1', // The tab groups identifier
      activate: function(event) { // Callback function if tab is switched
          var $tab = $(this);
          var $info = $('#nested-tabInfo2');
          var $name = $('span', $info);
          $name.text($tab.text());
          $info.show();
      }
});
$('#parentHorizontalTab1').easyResponsiveTabs({
      type: 'accordion', //Types: default, vertical, accordion
      width: 'auto', //auto or any width like 600px
      fit: true, // 100% fit in a container
      closed: 'accordion', // Start closed if in accordion view
      tabidentify: 'hor_1', // The tab groups identifier
      activate: function(event) { // Callback function if tab is switched
          var $tab = $(this);
          var $info = $('#nested-tabInfo2');
          var $name = $('span', $info);
          $name.text($tab.text());
          $info.show();
      }
});
$('.prod_inner').slick({
  dots: false,
  arrows: true,
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  responsive: [{
        breakpoint: 1600,
        settings: {
        slidesToShow: 4
        }
      },
      {
          breakpoint: 940,
          settings: {
          slidesToShow: 3
          }
      },
      {
          breakpoint: 767,
          settings: {
          slidesToShow: 2
          }
      },
      {
          breakpoint: 568,
          settings: {
          slidesToShow: 2
          }
      }
  ]
});
$('.review_slider').slick({
  dots: false,
  arrows: true,
  slidesToShow: 1,
  slidesToScroll: 1
});

$('.resp-tab-item').on('click', function() {       
    $('.prod_inner').slick("slickRemove");
    $('.prod_inner').slick("slickAdd");
});
$('.resp-accordion').on('click', function() {       
    $('.prod_inner').slick("slickRemove");
    $('.prod_inner').slick("slickAdd");
});
  $(document).ready(function ($) {
    $('.btn.plus').click(function (e) {
        e.preventDefault();
        fieldName = $(this).attr('field');
        var currentVal = parseInt($('input[name=' + fieldName + ']').val());
        if (!isNaN(currentVal)) {
            $('input[name=' + fieldName + ']').val(currentVal + 1);
        } else {
            $('input[name=' + fieldName + ']').val(1);
        }
    });
    $(".btn.minus").click(function (e) {
        e.preventDefault();
        fieldName = $(this).attr('field');
        var currentVal = parseInt($('input[name=' + fieldName + ']').val());
        if (!isNaN(currentVal) && currentVal > 1) {
            $('input[name=' + fieldName + ']').val(currentVal - 1);
        } else {
            $('input[name=' + fieldName + ']').val(1);
        }
    });
  });
$('.open-button').click(function (e) {
  document.getElementById("myForm").style.display = "block";
  $('.cancel').css("display","block");
  $(this).css("display","none");
})

$('.cancel').click(function (e) {
  document.getElementById("myForm").style.display = "none";
  $('.open-button').css("display","block");
  $(this).css("display","none");
});
  
  
    $('.secondlink').on('click',function (e) {
      e.preventDefault();     
      
      $('.support_section .navigation a').removeClass('active');
      var target = window.location.hash;
      var $target = $(target);
    });
  
  jQuery(window).on('hashchange', function(){
    var hash = window.location.hash;
     $('.support_section .navigation a').removeClass('active');
      var target = window.location.hash;
      var $target = $(target);    
});
  
  
  
    $(document).ready(function ($) {
      	
      function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
      };
      let elemId = getUrlParameter('tab')
      document.getElementById(elemId) ? (
        document.getElementById(elemId).click()
      ) : null;
      
      
    });
  
 });


